import { omniAtom } from "src/utils/atoms";

import { Loader } from "./types";

export const loadersAtom = omniAtom({
  key: "inlineLoaders",
  value: [] as Loader[],
});
